// List Overlay Menu Hover
$(document).ready(function () {
  const $items = $('.overlay-menu .list-link__list .list-link__list__item');

  $items.on('mouseenter', function () {
    $items.addClass('inactive').removeClass('active');
    $(this).addClass('active').removeClass('inactive');
  });

  $('.overlay-menu .list-link__list').on('mouseleave', function () {
    $items.removeClass('active inactive');
  });
});

// List Footer Menu Hover
$(document).ready(function () {
  const $items = $('.footer__top .list-link__list .list-link__list__item');

  $items.on('mouseenter', function () {
    $items.addClass('inactive').removeClass('active');
    $(this).addClass('active').removeClass('inactive');
  });

  $('.footer__top .list-link__list').on('mouseleave', function () {
    $items.removeClass('active inactive');
  });
});

// List Footer Meta Hover
$(document).ready(function () {
  const $items = $('.footer__bottom .list-link__list .list-link__list__item');

  $items.on('mouseenter', function () {
    $items.addClass('inactive').removeClass('active');
    $(this).addClass('active').removeClass('inactive');
  });

  $('.footer__bottom .list-link__list').on('mouseleave', function () {
    $items.removeClass('active inactive');
  });
});

// Overlay Menu Toggle
$("body").on("click", ".js-toggle-menu", function () {

  if ($(".js-toggle-menu").hasClass("is-active")) {

    $(".js-toggle-menu").removeClass("is-active");
    $("body").removeClass("menu-open");
    $(".overlay-menu").removeClass("open");

  } else {

    $(".overlay-menu").addClass("open");
    $(".js-toggle-menu").addClass("is-active");
    $("body").addClass("menu-open");

  }
});


$("body").on("click", ".site-main-wrapper", function () {
    if ($(".site-main-wrapper").hasClass("menuopen")) {
      $(".tool-burger").removeClass("open");
      $(".overlay-menu").removeClass("open");
      $(".site-main-wrapper").removeClass("menuopen");
    }
  });
